import React, { useEffect, useState } from 'react'
import { currencyFormat } from '../Functions';
import { useDispatch, useSelector } from 'react-redux';
import CheckCoupon from '../redux/hooks/CheckCoupon';
import { setErrorMessage, setSuccessMessage } from '../redux/slices/MessageSlice';
import { useNavigate } from 'react-router-dom';
import { setCode } from '../redux/slices/CodeSlice';

const PaymentDetails = ({price,city}) => {
    const dispatch=useDispatch(); 
    const [isCopon,setIsCopon]=useState(false);
    const [isDetails,setIsDetails]=useState(false);
    const [shipping,setShipping]=useState();
    const [Copon,setCopon]=useState();
    const [offer, setOffer] = useState(null);
    const [subTotal, setSubTotal] = useState(null);
    const [total, setTotal] = useState(null);
    const {setting}=useSelector((state)=>state.SettingReducer);
    const {makeRequest,isLoading,data,success}=CheckCoupon();
  
    
    const HandleCopon=(e)=>{
      e.preventDefault();
      if(Copon.length===8){
        makeRequest(
          {
            code:Copon,
          })
      }else{
        dispatch(setErrorMessage('كود غير صحيح '))
      }
    }
    useEffect(()=>{
      if(city.id==1||city.id==2){
        setShipping(setting?.shipping_costs_cairo)
      }else{
        setShipping(setting?.shipping_costs) 
      }
      
    },[city])
    useEffect(()=>{
      if(data){
        if(data.data.type==="fixed"){
          setOffer(data.data.value)
        }else{
          setOffer(((price*data.data.percent_off)/100));
        }
     
        dispatch(setCode(data.data.code))
      }
      
    },[data])
    useEffect(()=>{
      if(offer){
        setSubTotal(Number(price)-Number(offer)+Number(shipping))
      }else{
        setSubTotal(Number(price)+Number(shipping))
      }
    },[price,shipping,offer])
    useEffect(()=>{
        setTotal(subTotal+((subTotal*setting.taxes)/100))
     
    },[subTotal])
  return (
    <>

    <div className={`${isDetails?'d-flex flex-column':'d-none'}`}>
    <div > 
   <div className='d-flex justify-content-between my-2 pb-1 border-bottom'>
         <div>
             <p>ملخص السلة  </p>
         </div>
         <div>
           <p>{currencyFormat(price)} ج.م</p>
         </div>
   </div>
   {offer&&(
  <div className='d-flex justify-content-between my-2 pb-1 border-bottom'>
  <div>
      <p>قيمة الخصم </p>
  </div>
  <div>
    <p>{offer} ج.م</p>

  </div>
</div>
   )}
   <div className='d-flex justify-content-between my-2 pb-1 border-bottom'>
         <div>
             <p>تكلفة الشحن </p>
         </div>
         <div>
           <p>{shipping} ج.م</p>

         </div>
   </div>
 
 
   </div>
   {setting.taxes>0&&(
     <div className='d-flex justify-content-between my-2 pb-1 border-bottom'>
     <div>
         <p>ضريبة القيمة المضافة </p>
     </div>
     <div>
       <p>{setting.taxes} %</p>
     </div>
</div>
   )}
   
    
    </div>
    <div className='d-flex justify-content-between my-2'>
         <div>
             <h5>الإجمالي</h5>
         </div>
         <div>
           <h5>{currencyFormat(total)} ج.م </h5>
         </div>
   </div>
    
            <div className='mb-3'> 
                <p onClick={()=>setIsCopon(true)} style={{ position:'relative',display:isCopon?'none':'block',color:'red',cursor:'pointer',textDecoration:'underline'}}>لديك كوبون تخفيض ؟</p>
                <form onSubmit={(e)=>HandleCopon(e)} style={{ position:'relative',display:isCopon?'block':'none'}}>
                    <input onChange={(e)=>setCopon(e.target.value)} type="text" class="form-control" placeholder='أدخل كود الخصم'
                            />
                            {isLoading?(
                            <button style={{ position:'absolute',top:'0px',left:'0px'}} className=' btn-add d-flex gap-2 align-items-center justify-content-center' disabled 
                            >Loading
                            <div class="spinner-border spinner-border-sm"  role="status">
                              <span class="visually-hidden" >Loading...</span>
                            </div>
                            </button>
                            ):(
                            <button type="submit" style={{ position:'absolute',top:'0px',left:'0px'}}
                                                        className="btn-add">أضافة</button>
                            )}
                    
                </form>
            
            </div>
            <div>
                <div className='d-flex justify-content-center'>
                   <div className='payment-details ' onClick={()=>setIsDetails(!isDetails)}>
                     <p>تفاصيل الفاتورة</p>
                     {!isDetails?( <i class="fa-solid fa-chevron-down"></i>):( <i class="fa-solid fa-chevron-up"></i>)}
                    
                    
                   </div>
                </div>
                
            </div>
    </>
  
  )
}

export default PaymentDetails